import { createQueryKeys } from '@lukemorales/query-key-factory';

import type { Api } from '@/externals/corner-logis/Swagger';

import { CornerLogis } from '../../helpers';

export const 원스톱_솔루션_패키지_쿼리 = createQueryKeys('corner-logis-package', {
  패키지_목록_조회: ({ shopID, query }: { shopID: string; query: Api.GetPackagePagingList.RequestQuery }) => ({
    queryKey: [shopID, query] as const,
    queryFn: () => {
      return CornerLogis.proxy<Api.GetPackagePagingList.ResponseBody>({
        method: 'GET',
        path: '/api/v1/package/getPackageList',
        params: query,
        shopID,
      });
    },
  }),
  패키지_상품_목록_조회: ({
    shopID,
    packageName,
    query,
  }: {
    shopID: string;
    packageName?: string;
    query?: Api.GetGoodsByPackageName.RequestQuery;
  }) => ({
    queryKey: [shopID, packageName, query] as const,
    queryFn: () => {
      return CornerLogis.proxy<Api.GetGoodsByPackageName.ResponseBody>({
        method: 'GET',
        path: `/api/v1/package/${packageName}/getGoods`,
        params: query,
        shopID,
      });
    },
  }),
});
